// Lib
import { union } from 'lodash/fp';

const mergeCounts = (countA = 0, countB = 0) => countA + countB;
const mergeDistinctArrays = (arrayA = [], arrayB = []) => union(arrayA, arrayB);

const mergePropInto = (mergerFn) => (propName, obj, src, returnObject) => {
    if (src[propName] || obj[propName]) {
        returnObject[propName] = mergerFn(obj[propName], src[propName]);
    }

    return returnObject;
};

export const mergeArrayPropInto = mergePropInto(mergeDistinctArrays);
export const mergeCountPropInto = mergePropInto(mergeCounts);
